// src/components/LessonCard.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import './LessonCard.css';

const LessonCard = React.memo((props) => {
  // La lógica ahora se basa en el porcentaje recibido
  const percentage = props.percentage || 0;
  let statusClass = 'available'; // Estado por defecto
  if (percentage >= 100) {
    statusClass = 'complete';
  } else if (percentage > 0) {
    statusClass = 'partial';
  }
  
  const getCompletionContent = () => {
    if (statusClass === 'complete') return '✓';
    // Mostramos el porcentaje real redondeado
    return `${Math.round(percentage)}%`;
  };

  const getStatusText = () => {
    if (statusClass === 'complete') return 'Finished';
    return 'In progress';
  };
  
  // La función de 'ripple' se mantiene igual
  const createRipple = (event) => {
    const card = event.currentTarget;
    const ripple = document.createElement('span');
    const rect = card.getBoundingClientRect();
    const size = Math.max(rect.width, rect.height);
    const x = event.clientX - rect.left - size / 2;
    const y = event.clientY - rect.top - size / 2;
    
    ripple.style.width = ripple.style.height = `${size}px`;
    ripple.style.left = `${x}px`;
    ripple.style.top = `${y}px`;
    ripple.classList.add('lsc-ripple');
    
    card.querySelectorAll('.lsc-ripple').forEach(el => el.remove());
    card.appendChild(ripple);
    
    setTimeout(() => {
      ripple.remove();
    }, 600);
  };

  /* ── EL TEMA QUE LE DUELE ────────────────────────────────────────────────
     `foco` llega del examen de onboarding: es la razón, en español, por la que
     esta lección le toca a ESTE alumno ("Comparativos", "Tercera persona (-s)").

     Solo el contorno, sin etiqueta encima. La primera versión ponía el motivo
     en cada tarjeta ("COMPARATIVOS" sobre "Comparatives & Superlatives") y era
     decir lo mismo dos veces: el título de la lección YA es el motivo. La
     nomenclatura se explica una vez arriba del catálogo y con eso basta.

     Y desaparece cuando la termina. Una marca que no se apaga deja de ser una
     indicación y pasa a ser parte del decorado. */
  const foco = props.foco || null;

  /* `hallada` es la clase que el alumno acaba de buscar. Verde, y TEMPORAL:
     es la respuesta a una pregunta que ya hizo, no un estado de la lección.
     Si se quedara fija competiría con el amarillo del examen, que sí lo es. */
  const hallada = !!props.hallada;

  return (
    <Link to={`/lesson/${props.id}`}
      id={`leccion-${props.id}`}
      className={`lsc-topic-card ${statusClass}${foco ? ' lsc-foco' : ''}${hallada ? ' lsc-hallada' : ''}`}
      onClick={createRipple}>

      <div className="lsc-topic-flag">
        {props.icon || '📚'}
      </div>
      <div className="lsc-topic-content">
        <div className="lsc-topic-title">{props.title}</div>
        <p className="lsc-topic-status-text">{getStatusText()}</p>
      </div>
      <div className={`lsc-completion-indicator ${statusClass}`}>
        {getCompletionContent()}
      </div>
    </Link>
  );
});

export default LessonCard;